/**
 * Copy text to the clipboard. Requires a secure context (HTTPS, or a
 * platform-trusted local origin); returns false otherwise. The local dev
 * host (app.mealz.test) is plain HTTP and not a secure context, so this
 * silently no-ops there until local HTTPS is set up for both this app and
 * the mealz-api backend -- see INFRA-27.
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (!import.meta.client || text.length === 0) return false
  if (typeof navigator.clipboard?.writeText !== 'function') return false

  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
